const colors = require('tailwindcss/colors');
const plugin = require('tailwindcss/plugin');
const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
    important: true,

    content: [
        './vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php',
        './vendor/laravel/jetstream/**/*.blade.php',
        './storage/framework/views/*.php',
        './resources/views/**/*.blade.php',
        './resources/js/**/*.vue',
        './node_modules/@protonemedia/inertiajs-tables-laravel-query-builder/**/*.{js,vue}',
    ],

    theme: {
        extend: {
            spacing: {
                '128': '32rem',
                '160': '40rem',
                '176': '44rem'
            },

            boxShadow: {
                DEFAULT: '0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.02)',
                md: '0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                lg: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.01)',
                xl: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.01)',
            },

            colors: {
                gray: colors.slate,
                red: colors.rose,
                sky: {
                    50: '#eaf2ff',
                    100: '#d6e6ff',
                    200: '#b3d1ff',
                    300: '#8bb8ff',
                    400: '#4f93ff',
                    500: '#1875ff', // base
                    DEFAULT: '#1875ff',
                    600: '#1464e6',
                    700: '#0f4fc2',
                    800: '#0c3f99',
                    900: '#082e70',
                },
                violet: {
                    50:  '#F7F5FC',
                    100: '#DBD6E9 ',
                    200: '#DDD7EE',
                    300: '#B9B1D9',
                    400: '#8E82C7',
                    500: '#5A4AA3',
                    600: '#4B3D8C',
                    700: '#3E3271',
                    800: '#30265A',
                    900: '#211A43',
                    950: '#120E28',
                    light: '#8E82C7',
                    DEFAULT: '#3E3271',
                    dark: '#211A43',
                },
                'front-color': {
                    primary: '#000625',
                    secondary: '#dbedff'
                },
                greendack: {
                    50: '#e6fbfa',
                    100: '#c9f7f4',
                    200: '#a8f0eb',
                    300: '#7ee6df',
                    400: '#4fd8cf',
                    500: '#13cdc1', // base
                    600: '#10b8ad',
                    700: '#0e9e95',
                    800: '#0c7f78',
                    900: '#075e59',
                },
                primaryOrange: {
                    50:  '#fff3e0',  // background very light
                    100: '#ffe0b2',
                    200: '#ffcc80',
                    300: '#ffb84d',  // light
                    400: '#ffa726',
                    500: '#ff9700',  // base
                    DEFAULT: "#ff9700",
                    600: '#e68600',  // hover
                    700: '#cc7600',  // active / dark
                    800: '#a85f00',
                    900: '#7a4500',
                },
                marron: {
                    50:  '#FAF6F2',
                    100: '#F0E4D8',
                    200: '#E1C9B2',
                    300: '#CDA887',
                    400: '#B88963',
                    500: '#966641',
                    600: '#7D5234',
                    700: '#65412b',
                    800: '#4D3223',
                    900: '#362319',
                    950: '#1F130D',
                    light: '#B88963',
                    DEFAULT: '#65412B',
                    dark: '#362319',
                },
            },

            outline: {
                blue: '2px solid rgba(0, 112, 244, 0.5)',
            },

            fontFamily: {
                inter: ['Roboto', 'sans-serif'],
            },

            fontSize: {
                'xss':['0.60rem'],
                xs: ['0.75rem', { lineHeight: '1.5' }],
                sm: ['0.875rem', { lineHeight: '1.5715' }],
                base: ['1rem', { lineHeight: '1.5', letterSpacing: '-0.01em' }],
                lg: ['1.125rem', { lineHeight: '1.5', letterSpacing: '-0.01em' }],
                xl: ['1.25rem', { lineHeight: '1.5', letterSpacing: '-0.01em' }],
                '2xl': ['1.5rem', { lineHeight: '1.33', letterSpacing: '-0.01em' }],
                '3xl': ['1.88rem', { lineHeight: '1.33', letterSpacing: '-0.01em' }],
                '4xl': ['2.25rem', { lineHeight: '1.25', letterSpacing: '-0.02em' }],
                '5xl': ['3rem', { lineHeight: '1.25', letterSpacing: '-0.02em' }],
                '6xl': ['3.75rem', { lineHeight: '1.2', letterSpacing: '-0.02em' }],
            },

            screens: {
                xs: '480px',
            },

            borderWidth: {
                3: '3px',
            },

            minWidth: {
                36: '9rem',
                44: '11rem',
                56: '14rem',
                60: '15rem',
                72: '18rem',
                80: '20rem',
            },

            maxWidth: {
                '3xl': '58rem',
                '8xl': '88rem',
                '9xl': '96rem',
                'xxl': '100rem',
            },

            zIndex: {
                60: '60',
            },
        },

        screens: {
            'sm': '640px',
            // => @media (min-width: 640px) { ... }

            'md': '768px',
            // => @media (min-width: 768px) { ... }

            'lg': '1024px',
            // => @media (min-width: 1024px) { ... }

            'xl': '1280px',
            // => @media (min-width: 1280px) { ... }

            '2xl': '1536px',
            // => @media (min-width: 1536px) { ... }
        },
    },

    plugins: [
        require('@tailwindcss/forms'),
        require('@tailwindcss/typography')
    ],
};
